<style lang="stylus" scope>
    .math_menu
        position relative
        width 100%
        height 80px
        padding 14px 0 16px 0
        background-color var(--bg-color-tertiary)
        border-bottom 1px solid var(--border-color-box-6)
        z-index 9
        user-select none
        display flex
        align-items center

        .menu_middle
            height 100%
            max-width calc(100% - 90px)
            white-space nowrap
            overflow visible
            display flex
            align-items center
            justify-content space-around

            .menu-box
                position relative
                width min-content
                min-width 28px
                max-width 65px
                height 62px
                display flex
                flex-wrap wrap
                align-items center
                justify-content center
                margin-left 8px

                >p
                    font-size 12px
                    line-height 16px
                    color var(--text-color-primary)
                    width 100%
                    white-space nowrap
                    overflow hidden
                    text-overflow ellipsis

                &:first-child
                    margin-left 0

                .top-menu
                    width 28px
                    height 28px
                    padding 2px
                    border-radius 6px
                    transition all 0.2s ease-in-out
                    position relative
                    z-index 10

                    .ivu-tooltip-rel
                        width 100%
                        height 100%

                    &:hover
                        background var(--bg-color-float-tool-icon-hover)

                    input
                        display none

                    svg
                        display block
                        width 24px
                        height 24px
                        color var(--svg-color-gray-42-secondary)

                        &.math-saveMML
                            // 这种不需要改
                            stroke var(--bg-color-tertiary);
                        &.math-saveLatex
                            // 这种不需要改
                            fill var(--bg-color-tertiary);

                    .color-rect
                        position absolute
                        top 17px
                        left 4px
                        height 2px
                        width 16px
                        border-radius 1.5px

                .ivu-dropdown
                    width 28px
                    height 28px
                    border-radius 6px
                    transition all 0.2s ease-in-out
                    position relative
                    z-index 10

                    .ivu-dropdown-rel
                        width 28px
                        height 28px

                    .ivu-select-dropdown
                        width auto

                    .ivu-tooltip-rel
                        width 28px
                        height 28px
                        padding 2px
                        display block

                    &:hover
                        background rgba(0,0,0,0.04)

                    svg
                        display block
                        width 24px
                        height 24px
                        color var(--svg-color-gray-42-secondary)
                        &.math-savePic
                            fill var(--bg-color-tertiary);
                            stroke var(--bg-color-tertiary);
                    .ivu-dropdown-menu
                        .ivu-dropdown-item
                            text-align left

            .disabled-menu
                opacity 0.4
                pointer-events none
                cursor no-drop !important

            .line
                height 44px
                width 1px
                background rgba(0, 0, 0, 0.06)
                margin-left 6px

        .menu_middle_right
            display flex
            align-items center
            height 32px
            margin-left auto

            .menu_btn
                display flex
                justify-content center
                align-items center
                height 32px
                background var(--bg-color-dialog-cancel-btn)
                border-radius 6px
                user-select none
                cursor pointer
                transition background .2s linear

                &:not(:last-child)
                    margin-right 16px

                p
                    font-size 12px
                    line-height 20px

                &.gray
                    background var(--bg-color-dialog-cancel-btn)
                    padding 0 12px
                    p
                        color var(--text-color-primary)

                    &:hover
                        background var(--bg-color-dialog-cancel-btn-hover)

                &.blue
                    background var(--themeColor)
                    padding 0 14px
                    p
                        color #fff

                    &:hover
                        background var(--themeHover)
                .vip-icon
                    width 16px
                    height 16px
                    margin-right 4px

        .search-catalog
            width 25%
            margin-right 10px
            position relative
            z-index 10
            max-width 241px
            .ivu-select-selection
                height 28px
                .ivu-select-input
                    height 28px
                    cursor default

            // .ivu-select
            //     .ivu-select-selection
            //         border-color: #e0e0e0;
            .ivu-select-dropdown
                width 100px
                // height 100px
                overflow-x hidden

                .ivu-select-item
                    color black
                    max-width 260px
                    white-space nowrap
                    overflow hidden
                    text-overflow ellipsis

    .v-transfer-dom
        .ivu-modal1-footer
            padding 4px 18px 4px 18px

        .ivu-modal-body
            .downArea
                .span
                    display block

        .ivu-btn-large
            padding 5px 10px 5px 10px

        .unSaveBtn
            border 0

    .feedback
        font-size 14px
        line-height 58px
        text-align center
        cursor pointer
        user-select none
        transition color 0.2s linear

    .feedback:hover
        color #1890ff

    .feedback_line
        margin-bottom 10px

        p
            float left
            margin-right 20px
            line-height 32px

        #imgPreview
            display flex

        flex-wrap wrap

    .delbtn
        position absolute
        top 0
        right 0
        width 10px
        height 10px
        line-height 9px
        background-color #ff4d4f
        cursor pointer
        color #fff
        border-radius 50%

    .imgbox
        position relative
        width 83px
        height 83px
        margin 5px
        border 1px solid #cacaca
        border-radius 3px
        text-align center

    .imgsize
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        margin auto
        width 80px
        height auto
    .math-dialog-mask
        position fixed
        z-index 10
        background-color rgba(65, 68, 73, 0.5)
        top 0
        left 0
        bottom 0
        right 0
        z-index 100

    .math-ifsave-modal
        width 360px
        height 150px
        .math-ifsave-container
            padding 15px 20px
    .math-setting-modal
        width 290px
        .math-setting-container
            padding 10px 20px
            .upArea
                margin 10px 0 10px
                .ivu-checkbox-group-item
                    margin-right 45px
                    .ivu-checkbox
                        margin-right 8px;
                        &:not(.ivu-checkbox-checked)
                            .ivu-checkbox-inner
                                background-color var(--bg-color-tertiary)
            .downArea
                margin 10px 0 10px
                user-select none
                .ivu-radio-group-item
                    margin-right 45px
            .downArea
                .span
                    display block

    .floatFormulaFrame {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1000;
        width: 696px;
        height: 370px;
        background: var(--bg-color-tertiary);
        border: 0.5px solid rgba(0, 0, 0, 0.06);
        box-shadow: $box-shadow;
        border-radius: 8px;
        overflow: hidden;
        // font-family: arial, '\5B8B\4F53', sans-serif;

        .sa-close {
            display flex
            justify-content center
            align-items center
            width: 16px;
            height: 16px;
            position: absolute;
            top: 12px;
            right: 12px;
            user-select: none;
            background: var(--bg-color-tertiary);
            cursor: pointer;

            svg {
                width: 16px;
                height: 16px;
                color var(--svg-color-gray-42)
            }
        }

        .ivu-select-dropdown {
            width: 130px;
        }

        .frameTitle {
            height: 58px;
            display: flex;
            align-items: center;

            .catalog {
                cursor: pointer;
            }

            .box-title {
                margin-left: 10px;
                cursor: auto;
            }

            .formula-search-catalog {
                width: 100%;
                margin-top: 0;
                position: absolute;
                right: 52px;
                z-index: 10;
                max-width: 200px;
                .ivu-select-dropdown {
                    width: 100%;
                    padding: 6px;
                    background: #FFFFFF;
                    border: 1px solid var(--border-color-box-6);
                    /* 浮动条以及下拉框投影 */

                    box-shadow: $box-shadow;
                    border-radius: 8px;
                }
                .ivu-select-dropdown-list {
                    .ivu-select-item {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        border-radius: 6px;
                        color: var(--text-color-ivu-dropdown-item) !important;
                    }
                }
            }
        }

        .frameContent {
            display: flex;
            height: 288px;
            margin 0 24px 24px 24px;
            overflow: overlay;
            border: 1px solid var(--border-color-box-6);
            border-radius: 4px;

            .every-box {
                position: relative;
                width: 164px;
                height: 120px;
                // line-height 110px
                border: 1px solid var(--border-color-box-6);
                border-radius: 6px;
                margin-bottom: 12px;
                margin-right: 12px;
                text-align: center;
                user-select: none;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing border-box

                img {
                    max-width: 96%;
                    max-height: 106px;
                    vertical-align: middle;
                }
            }
            .frameLeft {
                height: 100%;
                overflow: overlay;
                flex-shrink: 0;
            }
            .frameRight {
                display: flex;
                flex-wrap: wrap;
                height: 100%;
                overflow: overlay;
                padding: 12px;
                padding-right 0;
            }
        }
    }
</style>
<i18n>
{
  "zh": {
    "tips": {
      "fileParseErr": "文件解析失败",
      "fileParseSucc": "文件解析成功",
      "fileLoadErr": "文件载入失败",
      "fileLoadSucc": "文件载入成功",
      "cutSuccess": "剪切成功",
      "copySuccess": "复制成功"
    },
    "openFile": "打开mml或latex格式的文件",
    "openFileShort": "打开",
    "newFile": "新建",
    "savePic": "保存为图片",
    "saveMML": "保存为MML",
    "saveLatex": "保存为Latex",
    "copyEdit": "复制",
    "cutEdit": "剪切",
    "editPaste": "粘贴",
    "undoEdit": "撤销",
    "redoEdit": "重做",
    "boldStyle": "加粗",
    "italicStyle": "倾斜",
    "colorStyle": "颜色",
    "leftAlign": "左对齐",
    "centerAlign": "居中对齐",
    "rightAlign": "右对齐",
    "setConfig": "设置",
    "confirm": "确定",
    "cancel": "取消",
    "styleConfig": {
      "title": "样式",
      "config1": "字母(多选)：",
      "option1_1": "粗体",
      "option1_2": "斜体",
      "config2": "数字(多选)：",
      "option2_1": "粗体",
      "option2_2": "斜体",
      "config3": "矩阵边框：",
      "option3_1": "无",
      "option3_2": "实线",
      "option3_3": "虚线",
      "config4": "矩阵行线：",
      "option4_1": "无",
      "option4_2": "实线",
      "option4_3": "虚线",
      "config5": "粘贴板文本：",
      "option5_1": "MathML",
      "option5_2": "Latex"
    },
    "dialog": {
      "title": "提示",
      "content": "是否保存当前公式"
    },
    "savePNG": "保存为PNG",
    "saveJPG": "保存为JPG"
  },
  "jp": {
    "tips": {
      "fileParseErr": "ファイルの解析に失敗しました",
      "fileParseSucc": "ファイルが正常に解析されました",
      "fileLoadErr": "ファイルの読み込みに失敗しました",
      "fileLoadSucc": "ファイルの読み込みに成功しました",
      "cutSuccess": "カット成功",
      "copySuccess": "コピー成功"
    },
    "openFile": "mml、latexフォーマットファイルを開く",
    "openFileShort": "開く",
    "newFile": "新規作成",
    "savePic": "画像にエクスポート",
    "saveMML": "MMLファイルにエクスポート",
    "saveLatex": "Latexファイルにエクスポート",
    "copyEdit": "コピー",
    "cutEdit": "切り取り",
    "editPaste": "貼り付け",
    "undoEdit": "元に戻す",
    "redoEdit": "やり直し",
    "boldStyle": "太字",
    "italicStyle": "斜体",
    "colorStyle": "色",
    "leftAlign": "左揃え",
    "centerAlign": "中央揃え",
    "rightAlign": "右揃え",
    "setConfig": "書式を設定",
    "confirm": "OK",
    "cancel": "キャンセル",
    "styleConfig": {
      "title": "スタイル",
      "config1": "英文字（複数選択可）：",
      "option1_1": "太字",
      "option1_2": "斜体",
      "config2": "数字（複数選択可）：",
      "option2_1": "太字",
      "option2_2": "斜体",
      "config3": "行列の枠：",
      "option3_1": "なし",
      "option3_2": "実線",
      "option3_3": "点線",
      "config4": "行列線：",
      "option4_1": "なし",
      "option4_2": "実線",
      "option4_3": "点線",
      "config5": "ペーストボードのテキスト：",
      "option5_1": "MathML",
      "option5_2": "Latex"
    },
    "dialog": {
      "title": "ご注意",
      "content": "公式を保存しますか"
    },
    "savePNG": "PNGとして保存",
    "saveJPG": "JPGとして保存"
  },
  "en": {
    "tips": {
      "fileParseErr": "File Parsing Failed",
      "fileParseSucc": "File Parsing Successfully",
      "fileLoadErr": "File Loading Failed",
      "fileLoadSucc": "File Loading Successfully",
      "cutSuccess": "Cut Successfully",
      "copySuccess": "Copy Successfully"
    },
    "openFile": "Open File in Mml or Latex Format",
    "openFileShort": "Open",
    "newFile": "Create",
    "savePic": "Save as Picture",
    "saveMML": "Save as MML",
    "saveLatex": "Save as Latex",
    "copyEdit": "Copy",
    "cutEdit": "Cut",
    "editPaste": "Paste",
    "undoEdit": "Undo",
    "redoEdit": "Redo",
    "boldStyle": "Bold",
    "italicStyle": "Italic ",
    "colorStyle": "Color",
    "leftAlign": "Align Left ",
    "centerAlign": "Align Center ",
    "rightAlign": "Align Right",
    "setConfig": "Set Style",
    "confirm": "OK",
    "cancel": "Cancel",
    "styleConfig": {
      "title": "Style",
      "config1": "Letters (multiple choices):",
      "option1_1": "Bold",
      "option1_2": "Italics",
      "config2": "Numbers (multiple choices):",
      "option2_1": "Bold",
      "option2_2": "Italics",
      "config3": "Matrix Borders:",
      "option3_1": "None",
      "option3_2": "Solid line",
      "option3_3": "Dotted line",
      "config4": "Matrix Lines:",
      "option4_1": "None",
      "option4_2": "Solid line",
      "option4_3": "Dotted line",
      "config5": "ClipBoard Text:",
      "option5_1": "MathML",
      "option5_2": "Latex"
    },
    "dialog": {
      "title": "Reminder:",
      "content": "Do you want to save the current formula?"
    },
    "savePNG": "Save as PNG",
    "saveJPG": "Save as JPG"
  },
  "de": {
    "tips": {
      "fileParseErr": "Dateianalyse fehlgeschlagen",
      "fileParseSucc": "Dateianalyse erfolgreich",
      "fileLoadErr": "Datei speichern fehlgeschlage",
      "fileLoadSucc": "Datei speichern erfolgreich",
      "cutSuccess": "Schnitt erfolgreich",
      "copySuccess": "Kopieren erfolgreich"
    },
    "openFile": "Datei im Mml or Latex Format öffnen",
    "openFileShort": "öffnen",
    "newFile": "Neu",
    "savePic": "Als Bild speichern",
    "saveMML": "Als ML speichern",
    "saveLatex": "Als latex speichern",
    "copyEdit": "Kopieren",
    "cutEdit": "Schneiden",
    "editPaste": "Einfügen",
    "undoEdit": "Rückgängig machen",
    "redoEdit": "Wiederherstellen",
    "boldStyle": "Fett gedruckt",
    "italicStyle": "Kursiv",
    "colorStyle": "Farbe",
    "leftAlign": "Linksbündig",
    "centerAlign": "Mittig",
    "rightAlign": "Rechtsbündig",
    "setConfig": "Style festlegen",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "styleConfig": {
      "title": "Steyles",
      "config1": "Buchstaben (Mehrfachauswahl)：",
      "option1_1": "Fett gedruckt",
      "option1_2": "Kursiv",
      "config2": "Zahlen (Mehrfachauswahl)：",
      "option2_1": "Fett gedruckt",
      "option2_2": "Kursiv",
      "config3": "Matrixgrenzen：",
      "option3_1": "Nichts",
      "option3_2": "Einfache Linie",
      "option3_3": "Gepunktete Linie",
      "config4": "Matrixlinien：",
      "option4_1": "Nichts",
      "option4_2": "Einfache Linie",
      "option4_3": "Gepunktete Linie",
      "config5": "ClipBoad Text：",
      "option5_1": "MathML",
      "option5_2": "Latex-Datei"
    },
    "dialog": {
      "title": "Hinweis",
      "content": "Die aktuelle Formel speichern? "
    },
    "savePNG": "Als PNG speichern",
    "saveJPG": "Als JPG speichern"
  },
  "fr": {
    "tips": {
      "fileParseErr": "Échec de l'analyse du fichier",
      "fileParseSucc": "Fichier analysé avec succès",
      "fileLoadErr": "Échec du chargement du fichier",
      "fileLoadSucc": "Fichier chargé avec succès",
      "cutSuccess": "Coupé avec succès",
      "copySuccess": "copié avec succès"
    },
    "openFile": "Ouvrir un fichier au format mml ou latex",
    "openFileShort": "öffnen",
    "newFile": "Nouveau",
    "savePic": "Enregistrer comme image",
    "saveMML": "Enregistrer en tant que fichier MML",
    "saveLatex": "Enregistrer en tant que fichier Latex",
    "copyEdit": "Copier",
    "cutEdit": "Couper",
    "editPaste": "Coller",
    "undoEdit": "Annuler",
    "redoEdit": "Refaire",
    "boldStyle": "Audacieux",
    "italicStyle": "Inclinaison",
    "colorStyle": "Couleur",
    "leftAlign": "Aligner à gauche",
    "centerAlign": "Aligner au centre",
    "rightAlign": "Aligner à droite",
    "setConfig": "Définir le style",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "styleConfig": {
      "title": "Style",
      "config1": "Lettres (choix multiples):",
      "option1_1": "Audacieux",
      "option1_2": "Italique",
      "config2": "Numéro (choix multiple):",
      "option2_1": "Audacieux",
      "option2_2": "Italique",
      "config3": "Bordure de la matrice:",
      "option3_1": "Aucun",
      "option3_2": "Ligne continue",
      "option3_3": "Ligne pointillée",
      "config4": "Ligne de matrice:",
      "option4_1": "Aucun",
      "option4_2": "Ligne continue",
      "option4_3": "Ligne pointillée",
      "config5": "Texte ClipBoard:",
      "option5_1": "MathML",
      "option5_2": "Latex"
    },
    "dialog": {
      "title": "Indice",
      "content": "Enregistrer la formule actuelle?"
    },
    "savePNG": "Enregistrer au format PNG",
    "saveJPG": "Enregistrer au format JPG"
  },
  "es": {
    "tips": {
      "fileParseErr": "Análisis de archivos fallido",
      "fileParseSucc": "Análisis de archivos con éxito",
      "fileLoadErr": "Fallo en la carga de archivos",
      "fileLoadSucc": "Carga de archivos con éxito",
      "cutSuccess": "Cortar con éxito",
      "copySuccess": "Copiado con éxito"
    },
    "openFile": "Archivo abierto en formato Mml o látex",
    "openFileShort": "Abrir",
    "newFile": "Crear",
    "savePic": "Guardar como pintura",
    "saveMML": "Guardar como MML",
    "saveLatex": "Guardar como Látex",
    "copyEdit": "Copiar",
    "cutEdit": "Cortar",
    "editPaste": "Pegar",
    "undoEdit": "Deshacer",
    "redoEdit": "Rehacer",
    "boldStyle": "Bold",
    "italicStyle": "Cursiva",
    "colorStyle": "Color",
    "leftAlign": "Alinear a la izquierda",
    "centerAlign": "Alinear el centro",
    "rightAlign": "Alinear a la derecha",
    "setConfig": "Establecer estilo",
    "confirm": "OK",
    "cancel": "Cancelar",
    "styleConfig": {
      "title": "Estilos",
      "config1": "Cartas (opciones múltiples)",
      "option1_1": "Negrita",
      "option1_2": "Cursiva",
      "config2": "Números (opciones múltiples)",
      "option2_1": "Negrita",
      "option2_2": "Cursiva",
      "config3": "Bordes de la matriz",
      "option3_1": "Ninguna",
      "option3_2": "Línea sólida",
      "option3_3": "Línea de puntos",
      "config4": "Líneas de la matriz",
      "option4_1": "Ninguna",
      "option4_2": "Línea sólida",
      "option4_3": "Línea de puntos",
      "config5": "Texto del ClipBoard",
      "option5_1": "MathML",
      "option5_2": "Látex"
    },
    "dialog": {
      "title": "Recordatorio",
      "content": "¿Quieres guardar la fórmula actual?"
    },
    "savePNG": "Guardar como PNG",
    "saveJPG": "Guardar como JPG"
  },
  "pt": {
    "tips": {
      "fileParseErr": "Análise de Ficheiro Falhada",
      "fileParseSucc": "Análise de Ficheiro feita com Sucesso",
      "fileLoadErr": "Carregamento de Ficheiro Falhado",
      "fileLoadSucc": "Carregamento de Ficheiro feito com Sucesso",
      "cutSuccess": "Cortado com Sucesso",
      "copySuccess": "Copiado com Sucesso"
    },
    "openFile": "Abrir Ficheiro em Mml ou Formato Latex",
    "openFileShort": "Abrir",
    "newFile": "Criar",
    "savePic": "Gravar como Imagem",
    "saveMML": "Gravar como MML",
    "saveLatex": "Gravar como Latex",
    "copyEdit": "Copiar",
    "cutEdit": "Cortar",
    "editPaste": "Colar",
    "undoEdit": "Desfazer",
    "redoEdit": "Refazer",
    "boldStyle": "Negrito",
    "italicStyle": "Itálico",
    "colorStyle": "Cor",
    "leftAlign": "Alinhar à Esquerda",
    "centerAlign": "Alinhar ao Centro",
    "rightAlign": "Alinhar à Direita",
    "setConfig": "Definir Estilo",
    "confirm": "OK",
    "cancel": "Cancelar",
    "styleConfig": {
      "title": "Estilos:",
      "config1": "Cartas (múltiplas escolhas):",
      "option1_1": "Negrito",
      "option1_2": "Itálico",
      "config2": "Números (múltiplas escolhas):",
      "option2_1": "Negrito",
      "option2_2": "Itálico",
      "config3": "Margens de Matriz:",
      "option3_1": "Nenhum",
      "option3_2": "Linha Sólida",
      "option3_3": "Linha Pontilhada",
      "config4": "Linhas de Matriz:",
      "option4_1": "Nenhum",
      "option4_2": "Linha Sólida",
      "option4_3": "Linha Pontilhada",
      "config5": "Texto de Área de Transferência:",
      "option5_1": "MathML",
      "option5_2": "Latex"
    },
    "dialog": {
      "title": "Alerta: ",
      "content": "Deseja gravar a fórmula atual?"
    },
    "savePNG": "Salvar como PNG",
    "saveJPG": "Salvar como JPG"
  },
  "it": {
    "tips": {
      "fileParseErr": "Analisi del File Fallita",
      "fileParseSucc": "Analisi del File Completata con Successo",
      "fileLoadErr": "Caricamento del File Fallito",
      "fileLoadSucc": "Caricamento del File Completato con Successo",
      "cutSuccess": "Taglio Eseguito Con Successo",
      "copySuccess": "Copia Eseguita con Successo"
    },
    "openFile": "Apri File in Formato MML o LaTex",
    "openFileShort": "Aprire",
    "newFile": "Crea",
    "savePic": "Salva come Immagine",
    "saveMML": "Salva come MML",
    "saveLatex": "Salva come LaTex",
    "copyEdit": "Copia",
    "cutEdit": "Taglia",
    "editPaste": "Incolla",
    "undoEdit": "Annulla",
    "redoEdit": "Ripeti",
    "boldStyle": "Grassetto",
    "italicStyle": "Italico",
    "colorStyle": "Colore",
    "leftAlign": "Allinea a Sinistra",
    "centerAlign": "Allinea al Centro",
    "rightAlign": "Allinea a Destra",
    "setConfig": "Imposta Stile",
    "confirm": "OK",
    "cancel": "Annulla",
    "styleConfig": {
      "title": "Stili:",
      "config1": "Lettere (scelte multiple):",
      "option1_1": "Grassetto",
      "option1_2": "Italico",
      "config2": "Numeri (scelte multiple):",
      "option2_1": "Grassetto",
      "option2_2": "Italico",
      "config3": "Bordi Matrice:",
      "option3_1": "Nessuno",
      "option3_2": "Linea Continua",
      "option3_3": "Linea Tratteggiata",
      "config4": "Linee Matrice:",
      "option4_1": "Nessuno",
      "option4_2": "Linea Continua",
      "option4_3": "Linea Tratteggiata",
      "config5": "Testo Appunti:",
      "option5_1": "MathML",
      "option5_2": "LaTex"
    },
    "dialog": {
      "title": "Promemoria:",
      "content": "Desideri salvare la formula attuale?"
    },
    "savePNG": "Salva come PNG",
    "saveJPG": "Salva come JPG"
  },
  "tw": {
    "tips": {
      "fileParseErr": "檔案解析失敗",
      "fileParseSucc": "檔案解析成功",
      "fileLoadErr": "檔案載入失敗",
      "fileLoadSucc": "檔案載入成功",
      "cutSuccess": "剪下成功",
      "copySuccess": "複製成功"
    },
    "openFile": "打開mml或latex格式的檔案",
    "openFileShort": "打開",
    "newFile": "新建",
    "savePic": "儲存為圖片",
    "saveMML": "儲存為MML檔案",
    "saveLatex": "儲存為Latex檔案",
    "copyEdit": "複製",
    "cutEdit": "剪下",
    "editPaste": "貼上",
    "undoEdit": "復原",
    "redoEdit": "取消復原",
    "boldStyle": "加粗",
    "italicStyle": "傾斜",
    "colorStyle": "顏色",
    "leftAlign": "左對齊",
    "centerAlign": "居中對齊",
    "rightAlign": "右對齊",
    "setConfig": "設置樣式",
    "confirm": "確定",
    "cancel": "取消",
    "styleConfig": {
      "title": "樣式",
      "config1": "字母(多選)：",
      "option1_1": "粗體",
      "option1_2": "斜體",
      "config2": "數字(多選)：",
      "option2_1": "粗體",
      "option2_2": "斜體",
      "config3": "矩陣邊框：",
      "option3_1": "無",
      "option3_2": "實線",
      "option3_3": "虛線",
      "config4": "矩陣行線：",
      "option4_1": "無",
      "option4_2": "實線",
      "option4_3": "虛線",
      "config5": "貼上板文本：",
      "option5_1": "MathML",
      "option5_2": "Latex"
    },
    "dialog": {
      "title": "提示",
      "content": "是否儲存當前公式"
    },
    "savePNG": "儲存為PNG",
    "saveJPG": "儲存為JPG"
  },
  "kr": {
    "tips": {
      "fileParseErr": "파일 구문 분석 실패",
      "fileParseSucc": "파일 구문 분석 성공 ",
      "fileLoadErr": "파일 로드 실패",
      "fileLoadSucc": "파일 로드 성공 ",
      "cutSuccess": "잘라내기 성공",
      "copySuccess": "복사 성공"
    },
    "openFile": "파일을 Latex 또는 Mml 형식으로 열기",
    "openFileShort": "열려 있는",
    "newFile": "만들기",
    "savePic": "그림으로 저장",
    "saveMML": "MML로 저장",
    "saveLatex": "Latex로 저장",
    "copyEdit": "복사",
    "cutEdit": "잘라내기",
    "editPaste": "붙여넣기",
    "undoEdit": "취소 ",
    "redoEdit": "다시 만들기 ",
    "boldStyle": "볼드체",
    "italicStyle": "이탤릭체",
    "colorStyle": "색깔 ",
    "leftAlign": "왼쪽 정렬",
    "centerAlign": "가운데 정렬",
    "rightAlign": "오른쪽 정렬",
    "setConfig": "스타일 설정",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "styleConfig": {
      "title": "스타일",
      "config1": "알파벳 (복수응답):",
      "option1_1": "볼드체",
      "option1_2": "이탤릭체",
      "config2": "숫자 (복수응답):",
      "option2_1": "볼드체",
      "option2_2": "이탤릭체",
      "config3": "행렬 경계:",
      "option3_1": "무",
      "option3_2": "실선",
      "option3_3": "점선",
      "config4": "행렬 선:",
      "option4_1": "무",
      "option4_2": "실선",
      "option4_3": "점선",
      "config5": "클립보드 텍스트:",
      "option5_1": "MathML",
      "option5_2": "Latex"
    },
    "dialog": {
      "title": "알림:",
      "content": "현재 공식을 저장하시겠습니까?"
    },
    "savePNG": "PNG로 저장",
    "saveJPG": "JPG로 저장"
  }
}
</i18n>
<template>
    <div class="math_menu">
        <div class="menu_middle">
            <div class="menu-box">
                <Tooltip class="top-menu" :content="$t('openFile')" placement="bottom-start">
                    <label for="inputFile" style="display: block">
                        <iconSymbol :name="'math-openFile'" class="open-file"></iconSymbol>
                        <input type="file" accept=".latex,.mml" id="inputFile" @change="chooseFile" />
                    </label>
                </Tooltip>
                <p>{{ $t("openFileShort") }}</p>
            </div>

            <div class="menu-box" v-if="false">
                <Tooltip class="top-menu" :content="$t('newFile')" placement="bottom-start" @click.native="clickMenu('createNew')">
                    <iconSymbol :name="'math-newFile'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("newFile") }}</p>
            </div>

            <div class="menu-box" @mouseleave="leaveSavePngTips()">
                <Dropdown trigger="click" placement="bottom-start">
                    <a href="javascript:void(0)">
                        <Tooltip :content="$t('savePic')" placement="bottom-start" :disabled="savePngTips">
                            <iconSymbol :name="'math-savePic'" class="math-savePic" @click.native="savePngTips = true"></iconSymbol>
                        </Tooltip>
                    </a>
                    <Dropdown-menu slot="list">
                        <Dropdown-item @click.native="saveImg('png')">{{ $t("savePNG") }}</Dropdown-item>
                        <Dropdown-item @click.native="saveImg('jpg')">{{ $t("saveJPG") }}</Dropdown-item>
                    </Dropdown-menu>
                </Dropdown>
                <p>{{ $t("savePic") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip class="top-menu" :content="$t('saveMML')" placement="bottom-start" @click.native="clickMenu('saveMml')">
                    <iconSymbol :name="'math-saveMML'" class="math-saveMML"></iconSymbol>
                </Tooltip>
                <p>{{ $t("saveMML") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip class="top-menu" :content="$t('saveLatex')" placement="bottom-start" @click.native="clickMenu('saveLatex')">
                    <iconSymbol :name="'math-saveLatex'" class="math-saveLatex"></iconSymbol>
                </Tooltip>
                <p>{{ $t("saveLatex") }}</p>
            </div>

            <div class="line"></div>

            <div class="menu-box">
                <Tooltip class="top-menu" :content="$t('copyEdit')" placement="bottom-start" @click.native="clickMenu('editCopy')">
                    <iconSymbol :name="'math-copyEdit'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("copyEdit") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip class="top-menu" :content="$t('cutEdit')" placement="bottom-start" @click.native="clickMenu('editCut')">
                    <iconSymbol :name="'math-cutEdit'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("cutEdit") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip class="top-menu" :content="$t('editPaste')" placement="bottom-start" @click.native="clickMenu('editPaste')">
                    <iconSymbol :name="'math-pasteEdit'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("editPaste") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip
                    class="top-menu"
                    :content="$t('undoEdit')"
                    placement="bottom-start"
                    :class="{ 'disabled-menu': !isUndo }"
                    :disabled="!isUndo"
                    @click.native="isUndo && clickMenu('editUndo')"
                >
                    <iconSymbol :name="'math-undoEdit'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("undoEdit") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip
                    class="top-menu"
                    :content="$t('redoEdit')"
                    placement="bottom-start"
                    :class="{ 'disabled-menu': !isRedo }"
                    :disabled="!isRedo"
                    @click.native="isRedo && clickMenu('editRedo')"
                >
                    <iconSymbol :name="'math-redoEdit'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("redoEdit") }}</p>
            </div>

            <div class="line"></div>

            <div class="menu-box">
                <Tooltip
                    class="top-menu"
                    :content="$t('boldStyle')"
                    :class="boldStyle == true ? 'active' : null"
                    :style="{ background: biEnble ? (isDarkTheme() ? '#ffffff29' : '#f6f6f8') : null }"
                    placement="bottom-start"
                    @click.native="biEnble && clickMenu('fontbold')"
                >
                    <iconSymbol :name="'math-boldStyle'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("boldStyle") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip
                    class="top-menu"
                    :content="$t('italicStyle')"
                    :class="italicStyle == true ? 'active' : null"
                    :style="{ background: biEnble ? (isDarkTheme() ? '#ffffff29' : '#f6f6f8') : null }"
                    placement="bottom-start"
                    @click.native="biEnble && clickMenu('fontitalic')"
                >
                    <iconSymbol :name="'math-italicStyle'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("italicStyle") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip class="top-menu" :content="$t('colorStyle')" placement="bottom-start" @click.native="clickMenu('fontcolor', $event)">
                    <iconSymbol :name="'math-colorIcon'" style="pointer-events: none"></iconSymbol>
                    <div class="color-rect" :style="`background: ${color}`"></div>
                </Tooltip>
                <p>{{ $t("colorStyle") }}</p>
            </div>

            <div class="line"></div>

            <div class="menu-box">
                <Tooltip
                    class="top-menu"
                    :content="$t('leftAlign')"
                    :class="alignStyle == 12 ? 'active' : null"
                    :style="{ background: alignEnble ? (isDarkTheme() ? '#ffffff29' : '#f6f6f8') : null }"
                    placement="bottom-start"
                    @click.native="alignEnble && clickMenu('leftAlign')"
                >
                    <iconSymbol :name="'math-leftAlign'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("leftAlign") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip
                    class="top-menu"
                    :content="$t('centerAlign')"
                    :class="alignStyle == 13 ? 'active' : null"
                    :style="{ background: alignEnble ? (isDarkTheme() ? '#ffffff29' : '#f6f6f8') : null }"
                    placement="bottom-start"
                    @click.native="alignEnble && clickMenu('centerAlign')"
                >
                    <iconSymbol :name="'math-centerAlign'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("centerAlign") }}</p>
            </div>

            <div class="menu-box">
                <Tooltip
                    class="top-menu"
                    :content="$t('rightAlign')"
                    :class="alignStyle == 14 ? 'active' : null"
                    :style="{ background: alignEnble ? (isDarkTheme() ? '#ffffff29' : '#f6f6f8') : null }"
                    placement="bottom-start"
                    @click.native="alignEnble && clickMenu('rightAlign')"
                >
                    <iconSymbol :name="'math-rightAlign'"></iconSymbol>
                </Tooltip>
                <p>{{ $t("rightAlign") }}</p>
            </div>

            <div class="line"></div>

            <div class="menu-box">
                <Tooltip class="top-menu" :content="$t('setConfig')" placement="bottom-start" @click.native="clickMenu('setArray')">
                    <iconSymbol name="math-setConfig"></iconSymbol>
                </Tooltip>
                <p>{{ $t("setConfig") }}</p>
            </div>
            <!-- <Tooltip class="top-menu" content='将当前公式添加到自定义公式' placement="bottom-start" @click.native="clickMenu('addSelf')">
                <iconSymbol name="math-edit-self">
                </iconSymbol>
            </Tooltip> -->

            <!-- <Tooltip class="top-menu" content='导出公式' placement="bottom-start" @click.native="clickMenu('exportImg')">
                <iconSymbol name="math-export">
                </iconSymbol>
            </Tooltip> -->
            <a v-if="!nolimit" class="feedback" href="https://support.qq.com/product/54162" target="_blank">反馈..</a>
        </div>

        <div class="menu_middle_right">
            <div class="menu_btn gray" v-if="lang == 'zh'" @click="showFormulaModal = true">
                <p>常用公式</p>
            </div>
            <div class="menu_btn blue" @click="confirmFunc">
                <VipIcon v-if="!vip" />
                <p>{{ $t("confirm") }}</p>
            </div>
        </div>

        <!-- 暂时只有中文有公式 不用翻译。 -->
        <div class="search-catalog" v-if="lang == 'zh' && false">
            <i-select v-model="modal5" placeholder="请输入您所需搜索的公式名称" filterable clearable @on-change="selectFormula">
                <i-option v-for="item in catalogList" :value="item.index + '.' + item.value" :key="item.value">{{ item.value }}</i-option>
            </i-select>
        </div>
        <div class="math-dialog-mask" v-show="modal1">
            <Dialog
                class="math-ifsave-modal"
                @close="modal1 = false"
                :extra="true"
                :title="$t('dialog.title')"
                :contentWidth="360"
                :contentHeight="150"
            >
                <div class="math-ifsave-container">
                    <div class="math-ifsave-line">
                        {{ $t("dialog.content") }}
                    </div>
                </div>
                <div class="dialog-btnbox-normal">
                    <div class="dialog-btn-ok" @click="ok">{{ $t("confirm") }}</div>
                    <div class="" @click="cancel">{{ $t("cancel") }}</div>
                </div>
            </Dialog>
        </div>
        <div class="math-dialog-mask" v-show="modal2">
            <Dialog
                class="math-ifsave-modal"
                @close="modal2 = false"
                :extra="true"
                :title="$t('dialog.title')"
                :contentWidth="360"
                :contentHeight="150"
            >
                <div class="math-ifsave-container">
                    <div class="math-ifsave-line">
                        {{ $t("dialog.content") }}
                    </div>
                </div>
                <div class="dialog-btnbox-normal">
                    <div class="dialog-btn-ok" @click="ok2">{{ $t("confirm") }}</div>
                    <div class="" @click="cancel2">{{ $t("cancel") }}</div>
                </div>
            </Dialog>
        </div>
        <!-- 暂时未发现用处 -->
        <!-- <Modal v-model="modal4" width="300px" @on-ok="ok4" ok-text="确认" cancel-text="取消">
            <p>提示：</p>
            <p>乱码文件才可以点击此按钮</p>
            <p>请确认是否点击</p>
        </Modal> -->
        <div class="math-dialog-mask" v-show="modal3">
            <Dialog
                class="math-setting-modal"
                @close="modal3 = false"
                :extra="true"
                :title="$t('styleConfig.title')"
                :contentWidth="290"
                :contentHeight="350"
            >
                <div class="math-setting-container">
                    <div class="upArea">
                        <span>{{ $t("styleConfig.config1") }}</span>
                        <CheckboxGroup v-model="letter">
                            <Checkbox :label="'Bold'">{{ $t("styleConfig.option1_1") }}</Checkbox>
                            <Checkbox :label="'Italics'">{{ $t("styleConfig.option1_2") }}</Checkbox>
                        </CheckboxGroup>
                    </div>
                    <div class="upArea">
                        <span>{{ $t("styleConfig.config2") }}</span>
                        <CheckboxGroup v-model="number">
                            <Checkbox :label="'Bold'">{{ $t("styleConfig.option2_1") }}</Checkbox>
                            <Checkbox :label="'Italics'">{{ $t("styleConfig.option2_2") }}</Checkbox>
                        </CheckboxGroup>
                    </div>
                    <div class="downArea">
                        <span class="span">{{ $t("styleConfig.config3") }}</span>
                        <RadioGroup v-model="button1">
                            <Radio :label="'None'">{{ $t("styleConfig.option3_1") }}</Radio>
                            <Radio :label="'SolidLine'">{{ $t("styleConfig.option3_2") }}</Radio>
                            <Radio :label="'DottedLine'">{{ $t("styleConfig.option3_3") }}</Radio>
                        </RadioGroup>
                    </div>
                    <div class="downArea">
                        <span class="span">{{ $t("styleConfig.config4") }}</span>
                        <RadioGroup v-model="button2">
                            <Radio :label="'None'">{{ $t("styleConfig.option4_1") }}</Radio>
                            <Radio :label="'SolidLine'">{{ $t("styleConfig.option4_2") }}</Radio>
                            <Radio :label="'DottedLine'">{{ $t("styleConfig.option4_3") }}</Radio>
                        </RadioGroup>
                    </div>
                    <div class="downArea">
                        <span class="span">{{ $t("styleConfig.config5") }}</span>
                        <RadioGroup v-model="button3">
                            <Radio :label="'MathML'">{{ $t("styleConfig.option5_1") }}</Radio>
                            <Radio :label="'Latex'">{{ $t("styleConfig.option5_2") }}</Radio>
                        </RadioGroup>
                    </div>
                </div>
                <div class="dialog-btnbox-normal">
                    <div class="dialog-btn-ok" @click="ok3">{{ $t("confirm") }}</div>
                    <div class="" @click="modal3 = false">{{ $t("cancel") }}</div>
                </div>
            </Dialog>
        </div>
        <!-- 暂时没发现用处
        <Modal v-model="modal6" width="300px" @on-ok="ok6" @on-cancel="cancel6" ok-text="确认" cancel-text="取消">
            <p>导出图片的名称：</p>
            <br>
            <Input v-model="nameValue" placeholder="请输入..." style="width: 200px" />
        </Modal> -->
        <!-- 没自定义公式 暂时注释
        <Modal v-model="modal7" width="300px" @on-ok="ok7" @on-cancel="cancel7" ok-text="确认" cancel-text="取消">
            <p>请输入：</p>
            <br>
            <Input v-model="nameSelf" ref='customName' placeholder="自定义公式名称..." @on-keyup.enter='ook7($event)' style="width: 200px" />
        </Modal> -->
        <!-- 没自定义公式 暂时注释
        <Modal v-model="modal8" width="300px" @on-ok="ok8" @on-cancel="cancel7" ok-text="确认" cancel-text="取消">
            <div tabindex="-1" ref='hasNameEle' @keyup.enter='ook8($event)'></div>
            <p>已存在相同名称的公式,是否更新公式?</p>
        </Modal> -->
        <!-- 暂时注释，没vip功能
        <Modal v-model="tipsShow" width="300" title="提示">
            <p>购买vip后解锁保存图片功能</p>
        </Modal> -->
        <div class="floatFrameMask" v-if="showFormulaModal" @click.self="closeWin">
            <div class="floatFormulaFrame">
                <div class="sa-close" @click="closeWin">
                    <iconSymbol name="math-close"></iconSymbol>
                </div>
                <div class="frameTitle">
                    <div class="formula-search-catalog">
                        <i-select
                            v-model="modal5"
                            placeholder="请输入您所需搜索的公式名称"
                            filterable
                            :clearable="true"
                            @on-change="selectFormula2"
                            @on-clear="resetSelectList"
                        >
                            <i-option v-for="item in catalogList" :value="item.index + '.' + item.value" :key="item.value">{{ item.value }}</i-option>
                        </i-select>
                    </div>
                </div>
                <div class="frameContent">
                    <div class="frameLeft">
                        <collapseMenu :list="menulist" @clickName="getCatalog" />
                    </div>
                    <div class="frameRight">
                        <Tooltip :content="item.hint" placement="bottom-end" v-for="(item, index) in boxList" :key="index">
                            <div class="every-box" @click="insertFormula(index)">
                                <img :src="item.path" :alt="item.hint" />
                            </div>
                        </Tooltip>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import fontSet from "../mixins/fontSet";
    import formulaData from "../mixins/formulaData";
    import Dialog from "@/app/components/Modals/Dialog.vue";
    import collapseMenu from "./collapseMenu.vue";
    import axios from "axios";
    export default {
        name: "",
        mixins: [fontSet, formulaData],
        inject: ["EDMathUI"],
        components: { Dialog, collapseMenu },
        data() {
            return {
                pasteHover: false,
                leftAlignHover: false,
                centerAlignHover: false,
                rightAlignHover: false,
                boldStyle: false,
                italicStyle: false,
                color: "#000000",
                alignStyle: "",
                modal1: false,
                modal2: false,
                modal3: false,
                modal4: false,
                modal5: "",
                modal6: false,
                modal7: false,
                modal8: false,
                getFileData: "",
                button1: "None",
                button2: "None",
                button3: "MathML",
                letter: ["Italics"],
                number: [],
                fileData: "",
                temData: "",
                isgbk: "",
                catalogList: [],
                biEnble: false,
                alignEnble: false,
                nameValue: "EdrawMath",
                nameSelf: "",
                isRedo: false,
                isUndo: false,
                tipsShow: false,
                showFormulaModal: false,
                boxList: [],
                savePngTips: false,
            };
        },
        methods: {
            leaveSavePngTips() {
                setTimeout(() => {
                    this.savePngTips = false;
                }, 200);
            },
            confirmFunc() {
                this.$bus.$emit("mathEditor", "ok");
            },
            ok() {
                this.$emit("setSave", true);
                this.modal1 = false;
            },
            cancel() {
                this.EDMathUI.view.openNewMml();
                this.modal1 = false;
            },
            ok2() {
                this.modal2 = false;
                this.$emit("setSave", true);
                this.getFileData = "";
                this.fileData = "";
            },
            cancel2() {
                this.modal2 = false;
                if (this.isgbk) {
                    var reader = new FileReader();
                    reader.readAsText(this.fileData, "gbk"); //发起异步请求
                    reader.addEventListener("load", (e) => {
                        try {
                            if (e.target.result) {
                                this.EDMathUI.view.openMml(e.target.result);
                            }
                        } catch (err) {
                            this.$edMessage.error(this.$t("tips.fileParseErr"));
                        }
                    });
                } else {
                    let isSuccess = this.EDMathUI.view.openMml(this.getFileData);

                    isSuccess ? this.$edMessage.success(this.$t("tips.fileLoadSucc")) : this.$edMessage.error(this.$t("tips.fileLoadErr"));
                }
                this.getFileData = "";
            },
            ok3() {
                if (this.button1 == "None") this.EDMathUI.lineType = 0;
                if (this.button1 == "SolidLine") this.EDMathUI.lineType = 1;
                if (this.button1 == "DottedLine") this.EDMathUI.lineType = 2;
                if (this.button2 == "None") this.EDMathUI.arrType = 0;
                if (this.button2 == "SolidLine") this.EDMathUI.arrType = 1;
                if (this.button2 == "DottedLine") this.EDMathUI.arrType = 2;
                //false表示非斜体
                //设置字母粗斜体
                this.EDMathUI.view.setInputMiItalic(false);
                this.EDMathUI.view.setInputMiBold(false);
                for (let i = 0; i < this.letter.length; i++) {
                    this.letter[i] == "Italics" && this.EDMathUI.view.setInputMiItalic(true);
                    this.letter[i] == "Bold" && this.EDMathUI.view.setInputMiBold(true);
                }
                //设置数字粗斜体
                this.EDMathUI.view.setInputMnItalic(false);
                this.EDMathUI.view.setInputMnBold(false);
                for (let i = 0; i < this.number.length; i++) {
                    this.number[i] == "Italics" && this.EDMathUI.view.setInputMnItalic(true);
                    this.number[i] == "Bold" && this.EDMathUI.view.setInputMnBold(true);
                }
                //设置粘贴板文本样式：
                // console.log(this.EDMathUI.view);
                if (this.button3 == "MathML") {
                    // this.EDMathUI.view.clipBoardTextType = 0;
                    this.EDMathUI.view.setClipBoardTextType(0);
                } else if (this.button3 == "Latex") {
                    // this.EDMathUI.view.clipBoardTextType = 1;
                    this.EDMathUI.view.setClipBoardTextType(1);
                }
                this.EDMathUI.view.focus();
                this.modal3 = false;
            },
            cancel3() {
                this.EDMathUI.view.focus();
            },
            ok4() {
                this.EDMathUI.view.openNewMml();
                this.EDMathUI.view.openMml(this.temData);
                this.fileData = "";
                this.temData = "";
            },
            ok6() {
                let getImg = this.EDMathUI.view.outputEDMathImage(this.nameValue);
                this.nameValue = "EdrawMath";
            },
            cancel6() {
                this.nameValue = "EdrawMath";
                this.EDMathUI.view.focus();
            },
            ook7(e) {
                // e.stopPropagation();
                // e.preventDefault();
                this.ok7();
                this.$nextTick(() => {
                    this.modal7 = false;
                });
            },
            ook8(e) {
                e.stopPropagation();
                e.preventDefault();
                // console.log(111);
                this.ok8();
                this.$nextTick(() => {
                    this.modal8 = false;
                });
            },
            ok7() {
                let hasname = false;
                let oldStorage = localStorage.getItem("selfStorage");
                if (oldStorage) {
                    let jsonSelf = JSON.parse(oldStorage);
                    if (jsonSelf.push) {
                        for (let tmpname of jsonSelf) {
                            if (tmpname[0] == this.nameSelf) {
                                hasname = true;
                            }
                        }
                    }
                }
                if (!hasname) {
                    this.ok8();
                } else {
                    this.modal8 = true;
                    this.$nextTick(() => {
                        this.$refs.hasNameEle.focus();
                    });
                }
            },
            ok8() {
                let mml = this.EDMathUI.view.outputMml();
                let png = this.EDMathUI.view.outputPngURL();
                let hasname = false;
                let oldStorage = localStorage.getItem("selfStorage");
                if (oldStorage) {
                    let newSelf = [this.nameSelf, mml, png];
                    let jsonSelf = JSON.parse(oldStorage);
                    if (jsonSelf.push) {
                        for (let tmpname of jsonSelf) {
                            if (tmpname[0] == this.nameSelf) {
                                hasname = true;
                                tmpname[1] = mml;
                                tmpname[2] = png;
                            }
                        }
                        if (!hasname) {
                            jsonSelf.push(newSelf);
                        }
                    } else {
                        localStorage.removeItem("selfStorage");
                    }
                    jsonSelf = JSON.stringify(jsonSelf);
                    localStorage.setItem("selfStorage", jsonSelf);
                } else {
                    let newSelf = [[this.nameSelf, mml, png]];
                    let jsonSelf = JSON.stringify(newSelf);
                    localStorage.setItem("selfStorage", jsonSelf);
                }

                this.$bus.$emit("updateBoxList", [this.nameSelf, mml, png, hasname]);

                this.nameSelf = "";
            },
            cancel7() {
                this.nameSelf = "";
            },
            //**dataURL to blob**
            dataURLtoBlob(img) {
                var arr = img.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            // 搜索公式并派发搜索结果到rightMenu组件
            selectFormula() {
                if (this.modal5) {
                    let getVal = this.modal5.split(".");
                    let i = parseInt(getVal[0]);
                    let sum = 0;
                    for (let val in this.pngList[i].list) {
                        if (val == getVal[1]) break;
                        sum++;
                    }
                    this.$bus.$emit("scrollSet", sum, i);
                }
            },
            selectFormula2() {
                if (this.modal5) {
                    let getVal = this.modal5.split(".");
                    let i = parseInt(getVal[0]);
                    let sum = 0;
                    for (let val in this.pngList[i].list) {
                        if (val == getVal[1]) break;
                        sum++;
                    }

                    this.boxList = [];
                    for (let val in this.pngList[i].list) {
                        this.boxList.push({
                            hint: val,
                            path: this.pngList[i].list[val],
                        });
                    }
                    this.isBox = true;
                    this.titleName = this.pngList[i].type;
                    if (this.pris.includes(this.pngList[i].type)) {
                        this.parentName = "小学";
                    } else if (this.mids.includes(this.pngList[i].type)) {
                        this.parentName = "初中";
                    } else if (this.higs.includes(this.pngList[i].type)) {
                        this.parentName = "高中";
                    } else if (this.unis.includes(this.pngList[i].type)) {
                        this.parentName = "大学";
                    }
                }
            },
            resetSelectList() {
                this.boxList = [];
                this.getCatalog("单位换算");
            },
            // 选择打开的文件
            chooseFile(e) {
                if (e.target.files[0]) {
                    let file = e.target.files[0];
                    e.target.value = "";
                    let fileName = file.name.split(".")[1];
                    if (fileName == "latex" || fileName == "mml") {
                        this.fileData = file;
                        var reader = new FileReader();
                        reader.readAsText(file, "utf-8"); //发起异步请求
                        reader.addEventListener("load", (e) => {
                            try {
                                if (e.target.result) {
                                    this.getFileData = e.target.result;
                                    this.isgbk = false;
                                    for (var _i = 0, text_1 = this.getFileData; _i < text_1.length; _i++) {
                                        var c = text_1[_i];
                                        if (c.charCodeAt(0) == 65533) {
                                            this.isgbk = true;
                                            break;
                                        }
                                        if (c.charCodeAt(0) > 20000) {
                                            break;
                                        }
                                    }

                                    if (
                                        this.EDMathUI.view.outputMml() !=
                                        `<math display="block" xmlns="http://www.w3.org/1998/Math/MathML"><mrow></mrow></math>`
                                    ) {
                                        this.modal2 = true;
                                        return;
                                    }
                                    if (this.isgbk) {
                                        var reader = new FileReader();
                                        reader.readAsText(this.fileData, "gbk"); //发起异步请求
                                        reader.addEventListener("load", (e) => {
                                            try {
                                                if (e.target.result) {
                                                    this.EDMathUI.view.openMml(e.target.result);
                                                }
                                            } catch (err) {
                                                this.$edMessage.error(this.$t("tips.fileParseErr"));
                                            }
                                        });
                                    } else {
                                        let isSuccess = this.EDMathUI.view.openMml(this.getFileData);

                                        isSuccess
                                            ? this.$edMessage.success(this.$t("tips.fileLoadSucc"))
                                            : this.$edMessage.error(this.$t("tips.fileLoadErr"));
                                    }
                                    this.getFileData = "";
                                }
                            } catch (err) {
                                this.$edMessage.error(this.$t("tips.fileParseErr"));
                            }
                        });
                        reader.addEventListener("error,abort", () => {
                            this.$edMessage.error(this.$t("tips.fileParseErr"));
                        });
                    } else {
                        this.$edMessage.error(this.$t("tips.fileLoadErr"));
                    }
                }
            },
            vipLimit() {
                this.$store.commit("setStatus", {
                    type: "saveMathSymbol",
                    data: true,
                });
                let list = this.$store.getters.vipStateFuncList;
                list = list.slice();
                if (!list.includes("funcShapeMath")) {
                    list.push("funcShapeMath");
                }
                if (!this.internal && this.lang != "zh") {
                    this.$store.commit("toPublicStatus", {
                        type: "upgradeTrigger",
                        data: "formulaEditor",
                    });
                    this.$store.commit("setStatus", {
                        type: "triggerType",
                        data: "formulaEditor",
                    });
                    this.$bus.$emit("togglePromodal", true, 2, 1);
                } else {
                    this.$bus.$emit("toggleFuncVipTip", { visible: true, vipFuncs: list, upgradeTrigger: "formulaEditor" });
                }

                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "formulaEditor",
                });
            },
            // 保存图片
            saveImg(type) {
                if (!this.vip) {
                    this.vipLimit();
                    return;
                }
                if (null != this.EDMathUI.view) {
                    switch (type) {
                        case "png": {
                            let img = this.EDMathUI.view.outputPngURL();
                            let blob = this.dataURLtoBlob(img);
                            saveAs(blob, "IMG.png");
                            break;
                        }
                        case "jpg": {
                            let img = this.EDMathUI.view.outputJpgURL();
                            let blob = this.dataURLtoBlob(img);
                            saveAs(blob, "IMG.jpg");
                            break;
                        }
                    }
                }
            },
            // 打开颜色选择器
            showColorPalette(e) {
                let payload = {
                    type: this.fmtType.mathColor,
                    index: 0,
                };
                this.$store.commit("setColor", payload);
                this.$nextTick(() => {
                    this.$store.dispatch("usePalette", { e, type: "mathColor" });
                });
            },
            emitColorEvent(color) {
                this.fontcolor(color);
            },
            // 点击按钮行为
            clickMenu(type, event) {
                console.log(this.EDMathUI);
                switch (type) {
                    //剪切
                    case "editCut": {
                        if (null != this.EDMathUI.view) {
                            let getCut = this.EDMathUI.view.editCut();
                            getCut == true ? this.$edMessage.success(this.$t("tips.cutSuccess")) : "";
                        }
                        break;
                    }
                    //粘贴
                    case "editPaste": {
                        if (null != this.EDMathUI.view) {
                            this.EDMathUI.view.editPaste();
                        }
                        break;
                    }
                    //复制
                    case "editCopy": {
                        if (null != this.EDMathUI.view) {
                            // alert("click 复制");
                            var getCopy = this.EDMathUI.view.editCopy();
                            getCopy == true ? this.$edMessage.success(this.$t("tips.copySuccess")) : "";
                        }
                        break;
                    }
                    //撤销
                    case "editUndo": {
                        if (null != this.EDMathUI.view) {
                            let isUndo = this.EDMathUI.view.editUndo();
                        }
                        break;
                    }
                    //恢复
                    case "editRedo": {
                        if (null != this.EDMathUI.view) {
                            let isRedo = this.EDMathUI.view.editRedo();
                        }
                        break;
                    }
                    //加粗
                    case "fontbold": {
                        this.fontbold();
                        this.EDMathUI.uifontbold == false ? (this.boldStyle = true) : (this.boldStyle = false);
                        break;
                    }
                    //斜体
                    case "fontitalic": {
                        this.fontitalic();
                        this.EDMathUI.uifontitalic == false ? (this.italicStyle = true) : (this.italicStyle = false);
                        break;
                    }
                    //字体颜色
                    case "fontcolor": {
                        this.showColorPalette(event);
                        break;
                    }
                    //左对齐
                    case "leftAlign": {
                        if (null != this.EDMathUI.view) {
                            this.alignEnble ? (this.alignStyle = 12) : "";
                            this.EDMathUI.view.setMtableColAlignType(0);
                        }
                        break;
                    }
                    //居中对齐
                    case "centerAlign": {
                        if (null != this.EDMathUI.view) {
                            this.alignEnble ? (this.alignStyle = 13) : "";
                            this.EDMathUI.view.setMtableColAlignType(1);
                        }
                        break;
                    }
                    //右对齐
                    case "rightAlign": {
                        if (null != this.EDMathUI.view) {
                            this.alignEnble ? (this.alignStyle = 14) : "";
                            this.EDMathUI.view.setMtableColAlignType(2);
                        }
                        break;
                    }
                    case "saveMml": {
                        if (!this.vip) {
                            this.vipLimit();
                            return;
                        }
                        if (null != this.EDMathUI.view) {
                            let mml = this.EDMathUI.view.outputMml();
                            let blob = new Blob([mml], {
                                type: "application/json;charset=gbk",
                                encoding: "gbk",
                            });
                            saveAs(blob, "MML.mml");
                        }
                        break;
                    }
                    case "saveLatex": {
                        if (!this.vip) {
                            this.vipLimit();
                            return;
                        }
                        if (null != this.EDMathUI.view) {
                            let latex = this.EDMathUI.view.outputLatex();
                            let blob = new Blob([latex], {
                                type: "application/json;charset=gbk",
                                encoding: "gbk",
                            });
                            saveAs(blob, "LATEX.latex");
                        }
                        break;
                    }
                    case "createNew": {
                        if (
                            this.EDMathUI.view.outputMml() == `<math display="block" xmlns="http://www.w3.org/1998/Math/MathML"><mrow></mrow></math>`
                        ) {
                            this.EDMathUI.view.openNewMml();
                            break;
                        }
                        this.modal1 = true;
                        break;
                    }
                    case "setArray": {
                        this.modal3 = true;
                        break;
                    }
                    case "exportImg": {
                        this.modal6 = true;
                        break;
                    }
                    case "addSelf": {
                        this.modal7 = true;
                        this.$nextTick(() => {
                            this.$refs.customName.focus();
                        });
                    }
                }
            },
            closeWin() {
                this.showFormulaModal = false;
                this.boxList = [];
                this.modal5 = "";
                this.EDMathUI.view.focus();
            },
            getCatalog(name) {
                console.log(name);
                // 弹出内容
                // 选择基础公式
                this.boxList = [];

                if (name) {
                    this.titleName = name;
                    let currentIndex = 0;
                    for (let i = 0; i < this.pngList.length; i++) {
                        if (name == this.pngList[i].type) {
                            currentIndex = i;
                            break;
                        }
                    }

                    if (this.pris.includes(this.pngList[currentIndex].type)) {
                        this.parentName = "小学";
                    } else if (this.mids.includes(this.pngList[currentIndex].type)) {
                        this.parentName = "初中";
                    } else if (this.higs.includes(this.pngList[currentIndex].type)) {
                        this.parentName = "高中";
                    } else if (this.unis.includes(this.pngList[currentIndex].type)) {
                        this.parentName = "大学";
                    }

                    for (let i in this.pngList[currentIndex].list) {
                        this.boxList.push({
                            hint: i,
                            path: this.pngList[currentIndex].list[i],
                        });
                    }
                }
            },
            insertFormula(index) {
                // 插入公式
                if (true) {
                    let sum = 0;
                    for (let i = 0; i < this.pngList.length; i++) {
                        if (this.pngList[i].type == this.titleName) break;
                        sum++;
                    }
                    axios
                        .get(this.mmlList[sum][index], {
                            responseType: "blob",
                        })
                        .then((res) => {
                            var reader = new FileReader();
                            reader.readAsText(res.data, "gbk"); //发起异步请求
                            reader.addEventListener("load", (e) => {
                                try {
                                    if (e.target.result) {
                                        this.EDMathUI.view.insertStdMml(e.target.result);
                                    }
                                } catch (err) {
                                    this.$edMessage.error("公式读取失败");
                                }
                            });
                        })
                        .catch((error) => {
                            this.$edMessage.error("公式读取失败");
                        });
                }
                this.closeWin();
            },
        },
        computed: {
            fmtType() {
                return this.$store.state.ui.fmtType;
            },
            nolimit() {
                return this.$store.state.ui.nolimitMath;
            },
            pris() {
                let pris = ["单位换算", "分数", "几何图形计算", "数量关系计算", "算术定律", "应用题公式"];
                return pris;
            },
            mids() {
                let mids = ["乘法与因式分解", "基础代数", "几何图形", "解析几何", "三角不等式", "三角函数", "基础数列", "一元二次方程"];
                return mids;
            },
            higs() {
                let higs = ["不等式", "初等函数", "导数", "方程", "基础知识", "数列", "图形几何", "向量"];
                return higs;
            },
            unis() {
                let unis = ["常微分方程", "有理函数", "代数", "微积分", "无穷级数", "概率论", "线性代数"];
                return unis;
            },
            menulist() {
                let arr = [];
                let formatData = (arr) => {
                    return arr.map((value, key) => {
                        return {
                            id: key,
                            name: value,
                        };
                    });
                };
                arr.push({
                    id: 0,
                    name: "小学",
                    children: formatData(this.pris),
                });
                arr.push({
                    id: 1,
                    name: "初中",
                    children: formatData(this.mids),
                });
                arr.push({
                    id: 2,
                    name: "高中",
                    children: formatData(this.higs),
                });
                arr.push({
                    id: 3,
                    name: "大学",
                    children: formatData(this.unis),
                });

                return arr;
            },
            // pics() {
            //     let pics = [];
            //     pics.push({
            //         //type: "importFile",
            //         hint: "打开mml或latex格式的文本",
            //         name: "open"
            //     });
            //     pics.push({
            //         type: "createNew",
            //         hint: "新建",
            //         name: "new"
            //     });
            //     pics.push({
            //         type: "saveImg",
            //         hint: "保存为图片",
            //         name: "pic"
            //     });
            //     pics.push({
            //         type: "saveMml",
            //         hint: "保存为mml文件",
            //         name: "mml"
            //     });
            //     pics.push({
            //         type: "saveLatex",
            //         hint: "保存为latex文件",
            //         name: "tex"
            //     });
            //     pics.push({
            //         type: "editCopy",
            //         hint: "复制",
            //         name: "copy"
            //     });
            //     pics.push({
            //         type: "editCut",
            //         hint: "剪切",
            //         name: "cut"
            //     });
            //     pics.push({
            //         type: "editPaste",
            //         hint: "粘贴",
            //         name: "paste"
            //     });
            //     this.isUndo
            //         ? pics.push({
            //               type: "editUndo",
            //               hint: "撤销",
            //               name: "undo"
            //           })
            //         : pics.push({
            //               type: "editUndoDis",
            //               name: "undo-dis",
            //               disabled: true
            //           });
            //     this.isRedo
            //         ? pics.push({
            //               type: "editRedo",
            //               hint: "恢复",
            //               name: "redo"
            //           })
            //         : pics.push({
            //               type: "editRedoDis",
            //               name: "redo-dis",
            //               disabled: true
            //           });
            //     this.biEnble
            //         ? pics.push({
            //               type: "fontbold",
            //               hint: "加粗",
            //               name: "ibold"
            //           })
            //         : pics.push({
            //               type: "fontboldDis",
            //               name: "ibold-dis",
            //               disabled: true
            //           });
            //     this.biEnble
            //         ? pics.push({
            //               type: "fontitalic",
            //               hint: "倾斜",
            //               name: "iItalic"
            //           })
            //         : pics.push({
            //               type: "fontitalicDis",
            //               name: "iItalic-dis",
            //               disabled: true
            //           });
            //     this.alignEnble
            //         ? pics.push({
            //               type: "leftAlign",
            //               hint: "设置选中的文本靠左对齐",
            //               name: "left-align"
            //           })
            //         : pics.push({
            //               type: "leftAlignDis",
            //               name: "left-dis",
            //               disabled: true
            //           });
            //     this.alignEnble
            //         ? pics.push({
            //               type: "centerAlign",
            //               hint: "设置选中的文本居中对齐",
            //               name: "center-align"
            //           })
            //         : pics.push({
            //               type: "centerAlignDis",
            //               name: "center-dis",
            //               disabled: true
            //           });
            //     this.alignEnble
            //         ? pics.push({
            //               type: "rightAlign",
            //               hint: "设置选中的文本靠右对齐",
            //               name: "right-align"
            //           })
            //         : pics.push({
            //               type: "rightAlignDis",
            //               name: "right-dis",
            //               disabled: true
            //           });

            //     return pics;
            // }
        },
        mounted() {
            // 接受字体粗细、是否斜体设置
            this.$bus.$on("fontSet", (font) => {
                font[0] == true ? (this.boldStyle = true) : (this.boldStyle = false);
                font[1] == true ? (this.italicStyle = true) : (this.italicStyle = false);
            });
            // 接受是否可点击设置
            this.$bus.$on("enbleSet", (enble) => {
                enble[0] == true ? (this.biEnble = true) : (this.biEnble = false);
                enble[1] == true ? (this.alignEnble = true) : (this.alignEnble = false);
                enble[2] == true ? (this.isUndo = true) : (this.isUndo = false);
                enble[3] == true ? (this.isRedo = true) : (this.isRedo = false);
            });
            // 接受对齐方式设置
            this.$bus.$on("colSet", (coltype_1) => {
                this.alignStyle = parseInt(coltype_1) + 12;
            });
            this.$bus.$on("mathColorStatus", (color) => {
                this.color = color[0];
            });
            this.$bus.$on("mathColorSet", (color) => {
                this.color = color;
                this.emitColorEvent(color);
                this.EDMathUI.view.setFontColor(color);
            });
            // 添加搜索栏里内容(组价要求不可重复)
            for (let i = 0; i < this.pngList.length; i++) {
                for (let variable in this.pngList[i].list) {
                    this.catalogList.push({
                        index: i,
                        value: variable,
                    });
                }
            }
            // this.$bus.$on("addCatalogList",()=>{});
        },
        beforeDestroy() {
            this.$bus.$off("mathColorStatus");
            this.$bus.$off("mathColorSet");
            this.$bus.$off("fontSet");
            this.$bus.$off("enbleSet");
            this.$bus.$off("colSet");
        },
    };
</script>
